module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-盛泰客户.e9eecc47.png";